import { useEffect } from 'react';

import { NavigateOptions, To, useNavigate, useParams } from 'react-router';

interface RedirectProps {
  /** Describes a location that is the destination of some navigation used in Link , useNavigate , etc. */
  to: To;
  options?: NavigateOptions;
}

/** Immediately redirect the user to a new route. */
const Redirect: React.FC<RedirectProps> = ({ to, options }) => {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    let path = typeof to === 'string' ? to : (to.pathname ?? '');
    Object.entries(params).forEach(([key, value]) => {
      if (!value) {
        return;
      }
      path = path.replace(`:${key}`, value);
    });
    if (typeof to === 'string') {
      navigate(path, options);
    } else {
      navigate(
        {
          ...to,
          pathname: path,
        },
        options,
      );
    }
  }, [navigate, to, options, params]);

  return null;
};

export default Redirect;
